import {Component, HostListener, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EMPTY} from "rxjs";
import {FormControl, Validators} from "@angular/forms";
import {ManufacturerService} from "../../../api/manufacturer.service";
import {ManufacturerCreateUpdateRequest} from "../../../api/model/manufacturer";
import {AuthService} from "../../../api/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {apiErrorToMessage} from "../../../common/util";

@Component({
  selector: 'app-manufacturer-edit-dialog',
  templateUrl: './manufacturer-edit-dialog.component.html',
  styleUrls: ['./manufacturer-edit-dialog.component.sass']
})
export class ManufacturerEditDialogComponent {
  abbreviationCtrl = new FormControl<string | null>(null);
  warrantyInMonthsCtrl = new FormControl<number | null>(null);
  hasSerialNumberByDefault = new FormControl<boolean>(true);
  responsibleCtrl = new FormControl<string[]>([], Validators.minLength(1));
  apiError: string | undefined;

  constructor(
    private manufacturerService: ManufacturerService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<ManufacturerEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ManufacturerEditDialogData,
    private _snackBar: MatSnackBar,
  ) {
    dialogRef.disableClose = true;
    this.warrantyInMonthsCtrl.setValue(data.warrantyInMonths);
    if (data.hasSerialNumberByDefault !== null) {
      this.hasSerialNumberByDefault.setValue(data.hasSerialNumberByDefault);
    }
    this.abbreviationCtrl.setValue(data.abbreviation);
    this.responsibleCtrl.setValue(data.responsible.slice());
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onPrimaryClick() {
    this.onSubmit()
  }

  onSubmit() {
    this.apiError = undefined;
    if (this.responsibleCtrl.value && this.responsibleCtrl.value.length > 0) {
      const request = {
        name: this.data.name,
        abbreviation: this.abbreviationCtrl.value,
        warrantyInMonths: this.warrantyInMonthsCtrl.value,
        hasSerialNumberByDefault: this.hasSerialNumberByDefault.value,
        responsible: this.responsibleCtrl.value,
      } as ManufacturerCreateUpdateRequest;

      this.manufacturerService.update(request)
        .subscribe({
          next: (response) => {
            console.log("ManufacturerEditDialogComponent saved manufacturer", response);
            this.dialogRef.close(response);
          },
          error: error => {
            console.log("ManufacturerEditDialogComponent failed to save", error)
            this.apiError = apiErrorToMessage(error);
            return EMPTY;
          }
        });
    }
  }

  isSubmitDisabled() {
    return (this.abbreviationCtrl.pristine && this.responsibleCtrl.pristine && this.warrantyInMonthsCtrl.pristine && this.hasSerialNumberByDefault.pristine)
      || !this.responsibleCtrl.value || this.responsibleCtrl.value?.length === 0;
  }
}

export interface ManufacturerEditDialogData {
  name: string;
  abbreviation: string | null;
  warrantyInMonths: number | null;
  hasSerialNumberByDefault: boolean | null;
  responsible: string[];
}
